import { FC } from "react";

export type { MarkdownProps } from "./types";
import type { MarkdownProps } from "./types";
import MarkdownInner from "./markdown-inner";

export { stripMarkdownLinks } from "./utils";

export const Markdown: FC<Readonly<MarkdownProps>> = (props) => {
  return <MarkdownInner {...props} />;
};
